module.exports = __webpack_public_path__ + "static/media/agent_2.3057d892.jpeg";